(() => {
  document.addEventListener('click', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const card = elem.closest('.swinger-card--calendar-current:not(.swinger-card--calendar-revealed)');

    if (!card) {
      return;
    }

    card.classList.add('swinger-card--calendar-revealed');
    window.setTimeout(() => {
      window.swinger.$('[data-tracking-label^="door"]', card)
        .forEach((elem) => {
          elem.removeAttribute('data-tracking-label');
        });
    });

    window.swinger.eventHub.trigger(card, 'swinger:explode');

    e.preventDefault();
  }, true);
})();
